/* istanbul ignore file */
const { httpClient } = require("../catalog.api.js");

const getMockups = () =>
  httpClient
    .get(`/mockups`, {
      "Content-Type": "application/json",
    })
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));

const saveMockup = (mockup) => {
  console.log(mockup, "savemockup");
  return httpClient
    .post(`/mockup`, { mockup }, { "Content-Type": "application/json" })
    .then((response) => {
      console.log(response.data);
      return response.data;
    })
    .catch((error) => Promise.reject(error));
};

const getMockup = (material) =>
  httpClient
    .get(`/mockup/${material}`, {
      "Content-Type": "application/json",
    })
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));

const getEditMockup = (material) =>
  httpClient
    .get(`/mockup/edit/${material}`, {
      "Content-Type": "application/json",
    })
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));

const destroyMockup = ({ id }) =>
  httpClient
    .delete(`/mockup/${id}`, {
      headers: {
        Authorization: "***",
      },
    })
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));

export { getMockups, saveMockup, getMockup, getEditMockup, destroyMockup };
